module.exports = require("@nrwl/workspace/src/utils/fileutils");